import { ClearCacheSWRKeys } from "services/SWRPartialKeyService";
import {
  AUTHENTICATED,
  AUTHENTICATED_FAILED,
  SHOW_AUTH_MESSAGE,
  HIDE_AUTH_MESSAGE,
  SIGNUP_SUCCESS,
  SHOW_LOADING,
  HIDE_LOADING,
  // SIGNOUT,
  REFRESH_TOKEN,
  REFRESH_TOKEN_FAILURE,
  REFRESH_TOKEN_SUCCESS,
  REFRESH_TOKEN_DISPATCHED,
  SIGNOUT_SUCCESS,
} from "../constants/Auth";

const initState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: "",
  refreshToken: "",
  permissions: {},
  roles: {},
  refreshTokenDispatched: false,
};

const auth = (state = initState, action) => {
  switch (action.type) {
    case AUTHENTICATED:
      return {
        ...state,
        loading: false,
        redirect: "/",
        token: action.accessToken,
        refreshToken: action.refreshToken,
        permissions: action.permissions,
        roles: action.roles,
        refreshTokenDispatched: false,
      };
    case AUTHENTICATED_FAILED: {
      return {
        ...state,
        token: null,
        loading: false,
      };
    }
    case REFRESH_TOKEN_DISPATCHED: {
      return {
        ...state,
        refreshTokenDispatched: true,
      };
    }
    case SHOW_AUTH_MESSAGE:
      return {
        ...state,
        message: action.message,
        showMessage: true,
        loading: false,
      };
    case HIDE_AUTH_MESSAGE:
      return {
        ...state,
        message: "",
        showMessage: false,
      };

    case SIGNOUT_SUCCESS: {
      ClearCacheSWRKeys();
      return {
        redirect: "/",
        token: null,
        permissions: null,
        loading: false,
      };
    }
    case SIGNUP_SUCCESS: {
      return {
        ...state,
        loading: false,
        token: action.token,
      };
    }
    case SHOW_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case HIDE_LOADING: {
      return {
        ...state,
        loading: false,
      };
    }
    case REFRESH_TOKEN:
      return {
        ...state,
        loading: true,
      };
    case REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        token: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        error: null,
      };
    case REFRESH_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default auth;
